import {apiPut, API_URL} from '../api'

export const editReferral = async (
    id,
    body: {
        exchange_maker_fee_rate: number
        exchange_taker_fee_rate: number
        max_reward_rate: number
        status: number
        referral_code: string
    },
) => {
    return await apiPut(API_URL, `admin/exchange/referral/${id}`, body)
}
